import React, { useState } from 'react';

const StepForwardIcon = ({
  width = 16,
  height = 16,
  color = '#7F7182',
  hoverColor = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  className = '',
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M6.65503 3.31L11.345 8L6.65503 12.69"
        stroke={isHovered ? hoverColor : color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StepForwardIcon;
